import React from 'react';

import { Box } from '@chakra-ui/react';
import { ProgressGraph } from 'screens/common/sidepanel/Goals/GoalProgress';

export const OKRProgressGraph = React.memo(
  ({ kRId, achieved, startValue, targetValue, startTS, dueTS, measure, progressLevel, goalClosureStatus }) => {
    const startDate = new Date(startTS);
    const dueDate = new Date(dueTS);

    return (
      <Box px={3}>
        <ProgressGraph
          goalId={kRId}
          achieved={achieved}
          initialValue={startValue}
          targetValue={targetValue}
          startDate={startDate}
          dueDate={dueDate}
          unit={measure}
          progressLevel={progressLevel} // this is used for color only for now.
          goalClosureStatus={goalClosureStatus}
          hideAxis
        />
      </Box>
    );
  }
);
